<template>
  <p>
    <a href="/"><img src="img/404error.png"></a>
  </p>
</template>

<script>
export default {
name: "Error404"
}
</script>

<style scoped>
p{
  position: absolute;
  top: 50%;
  left: 50%;
  height: 590px;
  margin-top: -295px;
  margin-left: -266px;
}
</style>